var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// eslint-disable-next-line @typescript-eslint/triple-slash-reference
///<reference path='../textarea/textarea-model.d.ts'/>
import { EventHandler, Property, createElement } from '@syncfusion/ej2-base';
import { TextArea } from '../textarea/textarea';
import { CaretPositionHelper } from './caret-helper';
export var ChatMessageRole;
(function (ChatMessageRole) {
    ChatMessageRole["System"] = "system";
    ChatMessageRole["User"] = "user";
    ChatMessageRole["Assistant"] = "assistant";
})(ChatMessageRole || (ChatMessageRole = {}));
export class SmartTextArea extends TextArea {
    /**
     * Constructor for creating the widget
     *
     * @private
     * @param {SmartTextArea} options - Specifies Smart text area model
     * @param {string | HTMLTextAreaElement} element - Specifies target element
     */
    constructor(options, element) {
        super(options, element);
    }
    render() {
        super.render();
        if (!(this.element instanceof HTMLTextAreaElement)) {
            return;
        }
        this.textArea = this.element;
        const smartTextArea = createElement('smart-textarea');
        smartTextArea.classList.add('e-smart-textarea');
        this.textArea.after(smartTextArea);
        if (this.showSuggestionOnPopup !== 'None') {
            const suggestionState = this.showSuggestionOnPopup === 'Enable' ? 'false' : 'true';
            this.textArea.setAttribute('data-inline-suggestions', suggestionState);
        }
        this.suggestionDisplay = this.shouldShowInlineSuggestions(this.textArea) ?
            new InlineSuggestion(smartTextArea, this.textArea) : new ContextSuggestion(smartTextArea, this.textArea);
    }
    wireEvents() {
        super.wireEvents();
        EventHandler.add(this.element, 'keyup', this.handleKeyUp, this);
        EventHandler.add(this.element, 'keydown', this.handleKeyDown, this);
        EventHandler.add(this.element, 'mousedown', this.removeExistingOrPendingSuggestion, this);
        EventHandler.add(this.element, 'focusout', this.removeExistingOrPendingSuggestion, this);
        this.element.addEventListener('scroll', (() => this.suggestionDisplay.reject()), {
            passive: true
        });
    }
    unWireEvents() {
        super.unWireEvents();
        EventHandler.remove(this.element, 'keyup', this.handleKeyUp);
        EventHandler.remove(this.element, 'keydown', this.handleKeyDown);
        EventHandler.remove(this.element, 'mousedown', this.removeExistingOrPendingSuggestion);
        EventHandler.remove(this.element, 'focusout', this.removeExistingOrPendingSuggestion);
        this.element.removeEventListener('scroll', (() => this.suggestionDisplay.reject()));
    }
    keydownHandler() {
        // Overridden to prevent default behavior
    }
    shouldShowInlineSuggestions(textArea) {
        const inlineSuggestions = textArea.getAttribute('data-inline-suggestions');
        if (inlineSuggestions) {
            return inlineSuggestions.toLowerCase() === 'true';
        }
        return !('ontouchstart' in window);
    }
    handleKeyDown(event) {
        switch (event.key) {
            case 'Tab':
                if (this.suggestionDisplay.isShowing()) {
                    this.suggestionDisplay.accept();
                    event.preventDefault();
                }
                break;
            case 'Alt':
            case 'Control':
            case 'Shift':
            case 'Command':
                break;
            default:
                if (this.suggestionDisplay.isShowing() && this.suggestionDisplay.currentSuggestion.startsWith(event.key)) {
                    CaretPositionHelper.insertCharacter(this.textArea, event.key);
                    event.preventDefault();
                    this.suggestionDisplay.show(this.suggestionDisplay.currentSuggestion.substring(event.key.length));
                    CaretPositionHelper.adjustScrollToCaretPosition(this.textArea);
                }
                else {
                    this.removeExistingOrPendingSuggestion();
                }
                break;
        }
    }
    handleKeyUp() {
        if (!this.suggestionDisplay.isShowing()) {
            clearTimeout(this.typingDebounceTimeout);
            this.typingDebounceTimeout = setTimeout(() => this.handleTypingPaused(), 350);
        }
    }
    handleTypingPaused() {
        return __awaiter(this, void 0, void 0, function* () {
            if (document.activeElement !== this.textArea) {
                return;
            }
            if (this.textArea.selectionStart === this.textArea.selectionEnd &&
                (this.textArea.selectionStart === this.textArea.value.length ||
                    this.textArea.value[this.textArea.selectionStart] === '\n')) {
                yield this.requestSuggestionAsync();
            }
        });
    }
    removeExistingOrPendingSuggestion() {
        clearTimeout(this.typingDebounceTimeout);
        if (this.pendingSuggestionAbort) {
            this.pendingSuggestionAbort.abort();
            this.pendingSuggestionAbort = null;
        }
        this.suggestionDisplay.reject();
    }
    createSuggestionPrompt(textBefore, textAfter) {
        let stringBuilder = 'Predict what text the user in the given ROLE would insert at the cursor position indicated by ^^^.\nOnly give predictions for which you have' +
            ' an EXTREMELY high confidence that the user would insert that EXACT text.\nDo not make up new information. If you are not sure, ' +
            'just reply with NO_PREDICTION.\n\nRULES:\n1. Reply with OK:, then in square brackets the predicted text, then END_INSERTION, and no other output.\n2. ' +
            'When a specific value or quantity cannot be inferred and would need to be provided, use the word NEED_INFO.\n3. ' +
            'If there is not enough information to predict any words that the user would type next, just reply with the word NO_PREDICTION.' +
            '\n4. NEVER invent new information. If you can not be sure what the user is about to type, ALWAYS stop the prediction with END_INSERTION.';
        const userPhrases = this.UserPhrases;
        if (userPhrases && userPhrases.length > 0) {
            stringBuilder += '\nAlways try to use variations on the following phrases as part of the predictions:\n';
            for (const phrase of userPhrases) {
                stringBuilder += `- ${phrase}\n`;
            }
        }
        const chatMessageList = [
            { role: ChatMessageRole.System, content: stringBuilder },
            { role: ChatMessageRole.User, content: 'ROLE: Family member sending a text\nUSER_TEXT: Hey, it is a nice day - the weather is ^^^' },
            { role: ChatMessageRole.Assistant, content: 'OK:[great!]END_INSERTION' },
            { role: ChatMessageRole.User, content: 'ROLE: Customer service assistant\nUSER_TEXT: You can find more information on^^^\n\nAlternatively, phone us.' },
            { role: ChatMessageRole.Assistant, content: 'OK:[ our website at NEED_INFO]END_INSERTION' },
            { role: ChatMessageRole.User, content: 'ROLE: Casual\nUSER_TEXT: Oh I see!\n\nWell sure thing, we can' },
            { role: ChatMessageRole.Assistant, content: 'OK:[ help you out with that!]END_INSERTION' },
            { role: ChatMessageRole.User, content: 'ROLE: Storyteller\nUSER_TEXT: Sir Digby Chicken Caesar, also know^^^' },
            { role: ChatMessageRole.Assistant, content: 'OK:[n as NEED_INFO]END_INSERTION' },
            { role: ChatMessageRole.User, content: 'ROLE: Customer support agent\nUSER_TEXT: Goodbye for now.^^^' },
            { role: ChatMessageRole.Assistant, content: 'NO_PREDICTION END_INSERTION' },
            { role: ChatMessageRole.User, content: 'ROLE: Pirate\nUSER_TEXT: Have you found^^^' },
            { role: ChatMessageRole.Assistant, content: 'OK:[ the treasure, me hearties?]END_INSERTION' },
            { role: ChatMessageRole.User, content: `ROLE: ${this.userRole}\nUSER_TEXT: ${textBefore}^^^${textAfter}` }
        ];
        return {
            messages: chatMessageList,
            temperature: 0.0,
            maxTokens: 400,
            stopSequences: ['END_INSERTION', 'NEED_INFO'],
            frequencyPenalty: 0.0,
            presencePenalty: 0.0
        };
    }
    requestSuggestionAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.pendingSuggestionAbort) {
                this.pendingSuggestionAbort.abort();
                return;
            }
            this.pendingSuggestionAbort = new AbortController();
            const requestDetails = {
                textAreaValue: this.textArea.value,
                cursorPosition: this.textArea.selectionStart
            };
            const suggestionData = {
                textBefore: requestDetails.textAreaValue.substring(0, requestDetails.cursorPosition),
                textAfter: requestDetails.textAreaValue.substring(requestDetails.cursorPosition)
            };
            const chatConfig = this.createSuggestionPrompt(suggestionData.textBefore, suggestionData.textAfter);
            let insertSuggestion;
            if (typeof this.aiSuggestionHandler === 'function') {
                const response = yield this.aiSuggestionHandler(chatConfig);
                insertSuggestion = this.validateSuggestion(response, suggestionData.textBefore);
            }
            if (insertSuggestion && requestDetails.textAreaValue === this.textArea.value &&
                requestDetails.cursorPosition === this.textArea.selectionStart) {
                if (!insertSuggestion.endsWith(' ')) {
                    insertSuggestion += ' ';
                }
                this.suggestionDisplay.show(insertSuggestion);
            }
        });
    }
    validateSuggestion(response, textBefore) {
        let suggestion;
        if (typeof response !== 'string' || response.length <= 5 || response.indexOf('OK:[') !== 0) {
            return '';
        }
        const endIndex = this.indexOfAny(response, ['.', '?', '!']);
        if (endIndex > 0 && response.length > endIndex + 1 && response[endIndex + 1] === ' ') {
            response = response.substring(0, endIndex + 1);
        }
        suggestion = response.substring(4).replace(/[\]\s]+$/, '');
        if (textBefore.length > 0 && textBefore[textBefore.length - 1] === ' ') {
            suggestion = suggestion.replace(/^\s+/, '');
        }
        return suggestion;
    }
    indexOfAny(str, chars) {
        for (let i = 0; i < str.length; i++) {
            if (chars.indexOf(str[`${i}`]) !== -1) {
                return i;
            }
        }
        return -1;
    }
    getModuleName() {
        return 'smarttextarea';
    }
    destroy() {
        super.destroy();
        this.textArea = null;
        this.suggestionDisplay = null;
        this.typingDebounceTimeout = null;
    }
}
__decorate([
    Property('')
], SmartTextArea.prototype, "userRole", void 0);
__decorate([
    Property([])
], SmartTextArea.prototype, "UserPhrases", void 0);
__decorate([
    Property()
], SmartTextArea.prototype, "aiSuggestionHandler", void 0);
__decorate([
    Property('None')
], SmartTextArea.prototype, "showSuggestionOnPopup", void 0);
class InlineSuggestion {
    get value() {
        const value = this.originalValueProperty.get.call(this.textArea);
        return this.isShowing() ? value.substring(0, this.suggestionStartPos) + value.substring(this.suggestionEndPos) : value;
    }
    set value(newValue) {
        this.originalValueProperty.set.call(this.textArea, newValue);
    }
    constructor(smartTextArea, textArea) {
        this.owner = smartTextArea;
        this.textArea = textArea;
        this.latestSuggestionText = '';
        this.suggestionStartPos = null;
        this.suggestionEndPos = null;
        this.virtualCaret = null;
        this.originalValueProperty = this.getOriginalValueProperty(textArea, 'value');
    }
    getOriginalValueProperty(obj, property) {
        while (obj) {
            const descriptor = Object.getOwnPropertyDescriptor(obj, property);
            if (descriptor) {
                return descriptor;
            }
            obj = Object.getPrototypeOf(obj);
        }
        throw new Error(`Property ${property} not found on object or its prototype chain`);
    }
    get valueIncludingSuggestion() {
        return this.originalValueProperty.get.call(this.textArea);
    }
    set valueIncludingSuggestion(newValue) {
        this.originalValueProperty.set.call(this.textArea, newValue);
    }
    isShowing() {
        return this.suggestionStartPos !== null;
    }
    show(suggestionText) {
        this.latestSuggestionText = suggestionText;
        this.suggestionStartPos = this.textArea.selectionStart;
        this.suggestionEndPos = this.suggestionStartPos + suggestionText.length;
        this.textArea.setAttribute('data-suggestion-visible', '');
        this.valueIncludingSuggestion = this.valueIncludingSuggestion.substring(0, this.suggestionStartPos) +
            suggestionText +
            this.valueIncludingSuggestion.substring(this.suggestionStartPos);
        this.textArea.setSelectionRange(this.suggestionStartPos, this.suggestionEndPos);
        if (!this.virtualCaret) {
            this.virtualCaret = new VirtualCaret(this.owner, this.textArea);
        }
        this.virtualCaret.show();
    }
    get currentSuggestion() {
        return this.latestSuggestionText;
    }
    accept() {
        this.textArea.setSelectionRange(this.suggestionEndPos, this.suggestionEndPos);
        this.suggestionStartPos = null;
        this.suggestionEndPos = null;
        if (this.virtualCaret) {
            this.virtualCaret.hide();
        }
        this.textArea.removeAttribute('data-suggestion-visible');
        CaretPositionHelper.adjustScrollToCaretPosition(this.textArea);
    }
    reject() {
        if (!this.isShowing()) {
            return;
        }
        const selectionStart = this.textArea.selectionStart;
        const selectionEnd = this.textArea.selectionEnd;
        this.valueIncludingSuggestion = this.valueIncludingSuggestion.substring(0, this.suggestionStartPos) +
            this.valueIncludingSuggestion.substring(this.suggestionEndPos);
        if (this.suggestionStartPos === selectionStart && this.suggestionEndPos === selectionEnd) {
            this.textArea.setSelectionRange(selectionStart, selectionStart);
        }
        this.suggestionStartPos = null;
        this.suggestionEndPos = null;
        this.textArea.removeAttribute('data-suggestion-visible');
        if (this.virtualCaret) {
            this.virtualCaret.hide();
        }
    }
}
class ContextSuggestion {
    constructor(container, textArea) {
        this.latestSuggestionText = '';
        this.showing = false;
        this.textArea = textArea;
        this.suggestionElement = document.createElement('div');
        this.suggestionElement.classList.add('smart-textarea-suggestion-overlay');
        this.suggestionElement.addEventListener('mousedown', (event) => this.handleSuggestionClicked(event));
        this.suggestionElement.addEventListener('touchend', (event) => this.handleSuggestionClicked(event));
        this.suggestionPrefixElement = document.createElement('span');
        this.suggestionTextElement = document.createElement('span');
        this.suggestionElement.appendChild(this.suggestionPrefixElement);
        this.suggestionElement.appendChild(this.suggestionTextElement);
        this.suggestionPrefixElement.style.opacity = '0.3';
        const computedStyle = window.getComputedStyle(this.textArea);
        this.suggestionElement.style.font = computedStyle.font;
        this.suggestionElement.style.marginTop = `${1.4 * parseFloat(computedStyle.fontSize)}px`;
        container.appendChild(this.suggestionElement);
    }
    get currentSuggestion() {
        return this.latestSuggestionText;
    }
    show(suggestionText) {
        this.latestSuggestionText = suggestionText;
        this.suggestionPrefixElement.textContent = suggestionText[0] !== ' ' ? this.getPrefixText(this.textArea, 20) : '';
        this.suggestionTextElement.textContent = suggestionText;
        const position = CaretPositionHelper.getTextAreaPosition(this.textArea);
        const style = this.suggestionElement.style;
        style.minWidth = null;
        this.suggestionElement.classList.add('smart-textarea-suggestion-overlay-visible');
        style.zIndex = this.textArea.style.zIndex + 1;
        style.top = `${position.top}px`;
        const leftPosition = position.left - this.suggestionPrefixElement.offsetWidth;
        if (!style.left || Math.abs(parseFloat(style.left) - leftPosition) > 10) {
            style.left = `${leftPosition}px`;
        }
        this.showing = true;
        const computedStyle = window.getComputedStyle(this.suggestionElement);
        const lineHeight = parseFloat(computedStyle.lineHeight);
        const paddingTop = parseFloat(computedStyle.paddingTop);
        const paddingBottom = parseFloat(computedStyle.paddingBottom);
        const lines = Math.round((this.suggestionElement.offsetHeight - paddingTop - paddingBottom) / lineHeight);
        if (lines > 2) {
            const elementWidth = this.suggestionElement.offsetWidth;
            style.minWidth = `calc(min(70vw, ${(lines * elementWidth) / 2}px))`;
        }
        const rect = this.suggestionElement.getBoundingClientRect();
        if (rect.right > document.body.clientWidth - 20) {
            style.left = `calc(${parseFloat(style.left) - (rect.right - document.body.clientWidth)}px - 2rem)`;
        }
    }
    accept() {
        if (this.showing) {
            CaretPositionHelper.insertCharacter(this.textArea, this.currentSuggestion);
            CaretPositionHelper.adjustScrollToCaretPosition(this.textArea);
            this.hide();
        }
    }
    reject() {
        this.hide();
    }
    hide() {
        if (this.showing) {
            this.showing = false;
            this.suggestionElement.classList.remove('smart-textarea-suggestion-overlay-visible');
        }
    }
    isShowing() {
        return this.showing;
    }
    handleSuggestionClicked(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.accept();
    }
    getPrefixText(textArea, maxLength) {
        const value = textArea.value;
        const selectionStart = textArea.selectionStart;
        for (let i = selectionStart - 1; i > selectionStart - maxLength; i--) {
            if (i < 0 || /\s/.test(value[`${i}`])) {
                return value.substring(i + 1, selectionStart);
            }
        }
        return '';
    }
}
class VirtualCaret {
    constructor(smartTextArea, textArea) {
        this.textArea = textArea;
        this.caretDiv = document.createElement('div');
        this.caretDiv.classList.add('smart-textarea-caret');
        smartTextArea.appendChild(this.caretDiv);
    }
    show() {
        const textAreaPosition = CaretPositionHelper.getTextAreaPosition(this.textArea);
        const caretStyle = this.caretDiv.style;
        caretStyle.display = 'block';
        caretStyle.top = textAreaPosition.top + 'px';
        caretStyle.left = textAreaPosition.left + 'px';
        caretStyle.height = textAreaPosition.height + 'px';
        caretStyle.zIndex = this.textArea.style.zIndex;
        caretStyle.backgroundColor = textAreaPosition.elemStyle.caretColor;
    }
    hide() {
        this.caretDiv.style.display = 'none';
    }
}
